import PropTypes from 'prop-types';
import React from 'react';
import { FormattedHTMLMessage } from '@bibliocommons/react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';

import './HoldInfoMessages.scss';

export default function HoldInfoMessages({ messageIds = [] }) {
  if (messageIds.length === 0) {
    return null;
  }
  return (
    <div>
      {messageIds.map(num => (
        <div className="cp-hold-info-message" key={`hold_info_msg_block${num}`}>
          <FormattedHTMLMessage id={`hold_info_msg_block${num}`} />
        </div>
      ))}
    </div>
  );
}

HoldInfoMessages.propTypes = {
  messageIds: ImmutablePropTypes.listOf(PropTypes.number).isRequired
};
